import classNames from "classnames";
import { JSX, PropsWithoutRef, ReactNode } from "react";
import { Link } from "react-router";
import Incidents from "~/components/Incidents";

export type CallToActionProps = Overwrite<Omit<PropsWithoutRef<JSX.IntrinsicElements["section"]>, "children">, {
  body: ReactNode;
  title: ReactNode;
}>;

export default function CallToAction({ body, className, title, ...props }: CallToActionProps) {
  return (
    <section {...props} className={classNames("overflow-hidden py-24", className)}>
      <div className="container">
        <div className="align-items-center gx-32 row">
          <div className="col-12 col-md-4">
            <Incidents enableMapIncidents={false} />
          </div>

          <div className="col-12 col-md-8">
            <div className="fs-3 fw-bold">{title}</div>

            <div className="fs-5_5 mt-6 text-body-secondary">{body}</div>

            <div className="d-flex flex-column">
              <div className="gap-6 flex-wrap hstack mt-8">
                <Link className="btn btn-primary" to="/sign-up">Start your trial</Link>

                <Link className="btn btn-outline-primary" to="/pricing">See plans and pricing</Link>
              </div>

              <p className="fs-8 mt-2 text-muted">14-day free trial, no credit card required</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
